exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hipster{display:inline-block;width:347px;height:120px;background-size:contain}.home{height:400px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.hipster{background-size:contain}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/main/webapp/app/home/home.css
// module id = 241
// module chunks = 0